import axios from 'axios';
import { env } from '@/utils/constants/env';
import axiosRetry from 'axios-retry';

const axiosInstance = axios.create({
  baseURL: env.apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// to validate token keycloak
axiosRetry(axiosInstance, {
  retries: 1,
  retryDelay: axiosRetry.exponentialDelay,
  retryCondition: error => {
    return error.response?.status === 401;
  },
});

export { axiosInstance };
